module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generation"
  }, [_c('div', {
    staticClass: "slider-wrapper"
  }, [_c('div', {
    staticClass: "sliders",
    style: ({
      transform: ("translateX(" + _vm.positionX + ")")
    })
  }, [_vm._l((_vm.sprouters), function(sprouter, index) {
    return [_c('Sprouter', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ({
          el: '.sprouters-experience-container',
          offset: -240,
        }),
        expression: "{\n                        el: '.sprouters-experience-container',\n                        offset: -240,\n                    }"
      }],
      key: index,
      attrs: {
        "isActive": _vm.isActive(index),
        "disabled": _vm.isDisabled(index),
        "img": sprouter.img,
        "name": sprouter.name,
        "position": sprouter.position
      },
      nativeOn: {
        "click": function($event) {
          _vm.activate(index)
        }
      }
    })]
  })], 2), _vm._v(" "), (_vm.showButton) ? [_c('div', {
    staticClass: "button-prev",
    class: {
      'button-disabled': _vm.prevBtnDisable
    },
    on: {
      "click": _vm.clickPrevBtn
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "button-next",
    class: {
      'button-disabled': _vm.nextBtnDisable
    },
    on: {
      "click": _vm.clickNextBtn
    },
    slot: "button-next"
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "sprouters-experience-container"
  }, [_vm._l((_vm.sprouters), function(sprouter, index) {
    return [_c('SprouterDetail', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isActive(index)),
        expression: "isActive(index)"
      }],
      key: index,
      attrs: {
        "photo": sprouter.photo,
        "name": sprouter.name,
        "position": sprouter.position,
        "article": sprouter.article,
        "activeGeneration": _vm.activeGeneration
      }
    })]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-609b538e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sectionTalking/Generation.vue
// module id = 680
// module chunks = 0